import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { ServiceService } from '../../../services/service.service';
import { Service } from '../../../models/service.model';

@Component({
  selector: 'app-list-service',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    FormsModule,
    DropdownModule,
    InputTextModule,
    PaginatorModule
  ],
  templateUrl: './list-service.component.html'
})
export class ListServiceComponent implements OnInit {

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  status = [
    { label: 'Ativos', value: true },
    { label: 'Inativos', value: false }
  ];

  services: Service[] = [];
  searchTerm = '';
  selectedStatus = this.status[0].value;
  loading = true;
  
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  currentPage: number = 1;

  constructor(
    private serviceService: ServiceService,
    public router: Router
  ) {
    this.searchSubscription = this.searchSubject.pipe(
          debounceTime(300),
          distinctUntilChanged()
        ).subscribe(term => {
          this.searchTerm = term;
          this.loadServices();
        });
  }

  ngOnInit(): void {
    this.loadServices();
  }

  onStatusChange(){
    this.loadServices();
  }

  onSearchChange(){
    this.searchSubject.next(this.searchTerm);
  }

  loadServices() {
    this.loading = true;
    this.serviceService.getAll(this.searchTerm, this.selectedStatus, this.currentPage).subscribe({
      next: (data) => {
        this.services = data.data;
        this.totalRecords = data.pagination.totalRecords;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.loadServices();
  }

  createService() {
    this.router.navigate(['/app/services/new']);
  }

  edit(service: Service) {
    this.router.navigate(['/app/services/edit', service.id]);
  }
}
